<div class="anchor-link" [ngClass]="{'anchor-link--show-text': block.data.showText}">
  <button class="anchor-link__link" (click)="scrollTo(block.data.link)"><span class="anchor-link__text">{{block.data.text}}</span></button>
</div>
